// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"asgZn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>App);
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("react-dom/client");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dateField = require("../dashboard/forms/date_field");
var _luxon = require("luxon");
var _chronoNode = require("chrono-node");
var _chronoNodeDefault = parcelHelpers.interopDefault(_chronoNode);
var _timestampTypes = require("../../../common/timestamp_types");
window.onload = ()=>{
    document.title = "Timestamp Converter - sesh.fyi";
    const container = document.getElementById("timestamp-converter");
    const root = (0, _client.createRoot)(container);
    root.render(App());
};
function App() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TimestampConverter, {});
}
function TimestampConverter() {
    const [date, setDate] = (0, _react.useState)(_luxon.DateTime.now());
    const is_markdown_list_visible = date && date.isValid;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {
                date: date,
                setDate: (new_date)=>setDate(new_date)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `${is_markdown_list_visible ? "" : " is-invisible"}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MarkdownList, {
                    date: date
                }, date?.toISO())
            })
        ]
    });
}
function DateInput(props) {
    const [rawInput, setRawInput] = (0, _react.useState)(_luxon.DateTime.now().toLocaleString((0, _luxon.DateTime).DATETIME_MED_WITH_WEEKDAY));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "control",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "columns is-mobile is-vcentered is-centered is-gapless",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-6-desktop is-8-tablet is-10-mobile",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        className: "input",
                        placeholder: "Ex: 08/21/23 at 6pm",
                        type: "text",
                        value: rawInput,
                        onChange: (val)=>{
                            setRawInput(val.target.value);
                            const parsed_date = parseTime(val.target.value);
                            props.setDate(parsed_date);
                        }
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "column is-1 has-text-centered",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DatePickerButton), {
                        initial_date: props.date?.toJSDate(),
                        allow_past_days: true,
                        onSubmit: (raw_date)=>{
                            const date = _luxon.DateTime.fromJSDate(raw_date);
                            setRawInput(date.toLocaleString((0, _luxon.DateTime).DATETIME_MED_WITH_WEEKDAY));
                            props.setDate(date);
                        },
                        modal_subtitle: "Select time using your local timezone"
                    }, props.date?.toISO())
                })
            ]
        })
    });
}
function MarkdownList(props) {
    const [copiedIndex, setCopied] = (0, _react.useState)(-1);
    const [copiedCounter, setCopiedCounter] = (0, _react.useState)(0);
    const elements = [];
    let index = 0;
    for(const key in 0, _timestampTypes.TIMESTAMP_TYPES){
        const formatter = (0, _timestampTypes.TIMESTAMP_TYPES)[key];
        const current_index = index;
        elements.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)(MarkdownItemRow, {
            isCopied: index === copiedIndex,
            setIsCopied: ()=>{
                setCopied(current_index);
                setCopiedCounter(copiedCounter + 1);
            },
            date: props.date,
            formatter: formatter,
            suffix: key
        }, key));
        index++;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "columns is-mobile is-centered markdown-list",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "column is-narrow",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
                className: "self-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                    children: elements
                })
            })
        })
    }, copiedCounter.toString());
}
function MarkdownItemRow(props) {
    if (!props.date) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {});
    const markdown = `<t:${props.date.toSeconds().toFixed(0)}:${props.suffix}>`;
    const markdown_id = `${props.suffix}_markdown`;
    (0, _react.useEffect)(()=>{
        if (props.isCopied) selectText(markdown_id);
    }, [
        props.isCopied
    ]);
    const dateMarkdown = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        id: markdown_id,
        className: "command-example--inline discord-timestamp-example",
        children: markdown
    });
    const dateString = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: props.formatter(props.date)
    });
    const copyIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "far fa-copy manual-link"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                className: "timestamp-row is-hidden-mobile",
                onClick: (event)=>{
                    navigator.clipboard.writeText(markdown);
                    props.setIsCopied();
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                        children: [
                            dateMarkdown,
                            props.isCopied && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "tooltip-parent",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "tooltip has-text-centered",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "has-text-centered",
                                        children: "copied"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        className: "has-text-weight-bold",
                        children: dateString
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        className: "",
                        children: copyIcon
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                className: "timestamp-row is-hidden-tablet",
                onClick: (event)=>{
                    navigator.clipboard.writeText(markdown);
                    props.setIsCopied();
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "has-text-weight-bold timestamp-name",
                            children: dateString
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "columns is-mobile is-variable is-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "column is-narrow",
                                    children: dateMarkdown
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "column is-narrow",
                                    children: copyIcon
                                }),
                                props.isCopied && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "tooltip-parent",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "tooltip has-text-centered",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "has-text-centered",
                                            children: "copied"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function parseTime(str) {
    let chrono_results = (0, _chronoNodeDefault.default).parse(str);
    if (chrono_results[0]?.start) return _luxon.DateTime.fromJSDate(chrono_results[0].start.date());
}
// https://gist.github.com/gubatron/6599366
function selectText(element_id) {
    const doc = document;
    const text = doc.getElementById(element_id);
    //all others
    const selection = window.getSelection();
    const range = doc.createRange();
    range.selectNodeContents(text);
    selection.removeAllRanges();
    selection.addRange(range);
}

},{"react/jsx-runtime":"dpQXr","react-dom/client":"i3gF3","react":"IMRgT","../dashboard/forms/date_field":"e6cg9","luxon":"fLWpi","chrono-node":"jT2kU","../../../common/timestamp_types":"eIHvQ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eIHvQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TIMESTAMP_TYPES", ()=>TIMESTAMP_TYPES);
var _luxon = require("luxon");
const TIMESTAMP_TYPES = {
    F: (d)=>d.toLocaleString({
            month: "long",
            weekday: "long",
            day: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "numeric"
        }),
    f: (d)=>d.toLocaleString({
            month: "long",
            year: "numeric",
            day: "2-digit",
            hour: "numeric",
            minute: "numeric"
        }),
    D: (d)=>d.toLocaleString({
            month: "long",
            day: "2-digit",
            year: "numeric"
        }),
    d: (d)=>d.toLocaleString({
            month: "2-digit",
            day: "2-digit",
            year: "numeric"
        }),
    t: (d)=>d.toLocaleString({
            hour: "numeric",
            minute: "numeric"
        }),
    T: (d)=>d.toLocaleString((0, _luxon.DateTime).TIME_WITH_SECONDS),
    R: (d)=>d.toRelative({}),
    s: (d)=>d.toLocaleString({
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "numeric"
        }),
    S: (d)=>d.toLocaleString({
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        })
};

},{"luxon":"fLWpi","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lIuHI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"52Uq9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertThisInitialized);
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kg9va":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"6RWgQ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6RWgQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5mymf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_getPrototypeOf);
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2OdDn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isNativeReflectConstruct);
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}]},["asgZn"], "asgZn", "parcelRequire7ff5", {})

//# sourceMappingURL=timestamp.e8b178b0.js.map
